import type { SpeciesFilterKey } from "../api/types";
import { SPECIES_FILTER_LABEL, SPECIES_FILTER_ORDER } from "./format";

interface Props {
  selected: ReadonlySet<SpeciesFilterKey>;
  counts: Record<SpeciesFilterKey, number>;
  onToggle: (key: SpeciesFilterKey) => void;
}

/**
 * Multi-select analysis-type filter. Lives next to the camera chip row and
 * combines with it via AND (camera) × OR (species). An empty selection
 * deliberately yields an empty result — the user opted out of everything.
 */
export function SpeciesFilter({ selected, counts, onToggle }: Props) {
  return (
    <div className="cam-chips" role="group" aria-label="Filter by detected species">
      {SPECIES_FILTER_ORDER.map((k) => {
        const active = selected.has(k);
        return (
          <button
            key={k}
            type="button"
            className={`chip ${active ? "active" : ""}`}
            onClick={() => onToggle(k)}
            aria-pressed={active}
          >
            {SPECIES_FILTER_LABEL[k]}
            <span className="count">{counts[k]}</span>
          </button>
        );
      })}
    </div>
  );
}
